module.exports = __webpack_public_path__ + "public/img/Mengelola Gaji Karyawan Dengan Microsoft Excel.9d4f3286.png";